import React from 'react'
import PropTypes from 'prop-types'
import NavigateBefore from '@mui/icons-material/NavigateBefore'

const NavigateBeforeIcon = ({ height, width, ...more }) => {

  return (
    <NavigateBefore
      height={height}
      width={width}
      {...more}
    />
  )
}

NavigateBeforeIcon.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
}

export default NavigateBeforeIcon
